import { Box, Chip, darken, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { EventStatus } from '../../types/Event';

const STATUS_COLORS: Record<string, string> = {
  planning: '#c0c0c0',
  in_progress: '#AD49E1',
  scheduled: '#42A5F5',
  complete: '#35B23D',
};

interface IStatusPillProps {
  status: EventStatus;
  text?: string;
  color?: string;
}

const StatusPill: React.FC<IStatusPillProps> = ({ status, text, color }) => {
  const snakeCaseStatus = _.snakeCase(status);
  const displayText = text || _.startCase(_.toLower(snakeCaseStatus));
  const backgroundColor = color || STATUS_COLORS[snakeCaseStatus] || '#c0c0c0';
  const borderColor = darken(backgroundColor, 0.2);

  return (
    <Chip
      size="small"
      label={displayText}
      sx={{ backgroundColor: `${backgroundColor}30`, border: `1px solid ${borderColor}` }}
    />
  );
};

export default StatusPill;
